import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ActionButtons, {
  type ActionButtonType,
} from 'further-ui/components/ActionButtons';
import { Row } from 'further-ui/components/Layout';
import { FC, PropsWithChildren, ReactNode } from 'react';
import FiltersGroup from './FiltersGroup';

export { default as Filter } from './Filter';
export { FiltersGroup };

type Props = {
  className?: string;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  align?: 'flex-start' | 'center' | 'flex-end';
  actions?: Array<ActionButtonType>;
  customActions?: ReactNode;
};

const ButtonsContainer = styled(Box)({
  display: 'flex',
  flexBasis: 'content',
  flexShrink: 0,
});

const PageFilters: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  justify = 'flex-start',
  align = 'center',
  actions,
  customActions,
}) => {
  const showDefaultButtons = !!actions?.length && !customActions;

  return (
    <Row
      spacing="md"
      centered
      breakpoint="md"
      fullWidth
      className={className}
      justify="space-between"
    >
      <FiltersGroup className={className} justify={justify} align={align}>
        {children}
      </FiltersGroup>
      {customActions || showDefaultButtons ? (
        <ButtonsContainer>
          {customActions ?? <ActionButtons actions={actions ?? []} />}
        </ButtonsContainer>
      ) : null}
    </Row>
  );
};

export default PageFilters;
